(function($, window, Contenda) {
    $(document).ready(ready);

    $(document).on('cms.ready', cmsReady);

    function ready() {
        if($('body[ng-controller]').length < 1) {
            $(document).trigger('cms.ready');
        } else {
            $(document).data('frontenda',true);
        }
    }

    function cmsReady() {
        let $widgetSections = $('.widgetSection');
        if($widgetSections.length > 0) {
            let observerOptions = {
                root: null, // relative to document viewport
                rootMargin: '0px 0px 20%', // margin around root. Values are similar to css property. Unitless values not allowed
                // threshold: 1.0 // visible amount of item shown in relation to root
            };

            let observer = new IntersectionObserver(intersectionCallback, observerOptions);

            $widgetSections.each(function setupObserver(idx, elm) {
                Contenda.log('observe element', elm);
                observer.observe(elm);
            });
        } else {
            console.warn('No widget sections found');
        }

        $(document).on('cms.add', function sectionAdd(evt, arg, arg2) {
            // console.log('cms.add', evt, arg, arg2);
            let $newSection = $('.widgetSection').not($widgetSections);
            // console.log('newSection?', $newSection);
            if($newSection.length) {
                $newSection.trigger('cms.intersect', [null, $newSection]);
                $newSection.data('cms.intersect', true);
            }
        })
    }

    // $widgetSections.get().forEach(section => observer.observe(section));
    function intersectionCallback(entries, observer) {
        /* @var IntersectionObserverEntry entries */
        entries.forEach(function handleIntersect(entry) {
            let $target = $(entry.target);
            Contenda.log('handleIntersect', entry, $target);
            // if($target.data('cms.intersect')) {
            //     observer.unobserve(entry.target);
            //     return;
            // }
            if(entry.isIntersecting || entry.isVisible) {
                Contenda.log('isIntersecting or isVisible', $target);
                $target.trigger('cms.intersect', [entry, $target]);
                $target.data('cms.intersect', true);

                observer.unobserve(entry.target);
            }
        });

    }

})(jQuery, window, window.Contenda);